import { render, staticRenderFns } from "./AppCollapseLeadItem.vue?vue&type=template&id=9c1f12ea&"
import script from "./AppCollapseLeadItem.vue?vue&type=script&lang=js&"
export * from "./AppCollapseLeadItem.vue?vue&type=script&lang=js&"
import style0 from "./AppCollapseLeadItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports